import { LearningComponents } from "@feature/procedure-control";
import { useParams } from "react-router-dom";
import { memo } from "react";

const EmployeesTraining = memo(() => {
  const { id } = useParams<{ id: string }>();

  if (typeof id === "undefined") {
    return null;
  }

  return (
    <LearningComponents
      withoutFilters
      withoutEmpty
      defaultFilters={{
        isRequired: true,
        employees: [+id],
      }}
      ignoredKeys={["companyName", "departmentTitle", "positionTitle"]}
    />
  );
});

export default EmployeesTraining;
